module.exports = __webpack_public_path__ + "img/eyes_male_extra_thin.7a4daeb7.png";